// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__21DCr","bigColWidth":"Table_bigColWidth__2EsXc","biggerColWidth":"Table_biggerColWidth__3HIIe","row":"Table_row__3S6xS","col":"Table_col__2J3tt"};